import { makeStyles, tokens, Title1, Body1, Button } from '@fluentui/react-components';

const useStyles = makeStyles({
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: tokens.spacingVerticalXXL,
    gap: tokens.spacingHorizontalL,
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  title: {
    margin: 0,
  },
  description: {
    color: tokens.colorNeutralForeground3,
    margin: 0,
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    flexShrink: 0,
  },
});

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  action?: React.ReactNode; // Alias for single action
  primaryAction?: {
    label: string;
    icon?: React.ReactNode;
    onClick: () => void;
  };
}

export function PageHeader({ title, description, actions, action, primaryAction }: PageHeaderProps) {
  const styles = useStyles();

  return (
    <div className={styles.header}>
      <div className={styles.titleSection}>
        <Title1 className={styles.title}>{title}</Title1>
        {description && <Body1 className={styles.description}>{description}</Body1>}
      </div>
      <div className={styles.actions}>
        {actions}
        {action}
        {primaryAction && (
          <Button
            appearance="primary"
            icon={primaryAction.icon as React.ReactElement}
            onClick={primaryAction.onClick}
          >
            {primaryAction.label}
          </Button>
        )}
      </div>
    </div>
  );
}
